// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1f6cc370","453":"3935979b","455":"6c64c0b2"}[chunkId] + ".chunk.js";
};